var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.matches),function(input){return _c('mz-search-box',{key:input.id,attrs:{"input":input,"query-param":_vm.queryParam,"search-url":_vm.searchUrl,"placement":_vm.placement,"delay":_vm.delay,"query-on-hover":_vm.queryOnHover},on:{"change":_vm.onChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }